import { maxBy } from "lodash";
import { IFormData } from "../dto/form";

import { IBundle } from "../dto/bundle";

// Must match StripeService.IsTaxable in gethair-api.
// Switzerland is a third country: no Austrian VAT, with or without a tax id.
export const includesVat = (values?: IFormData) => {
	if (values?.country?.value?.trim().toUpperCase() === "CH") {
		return false;
	}

	return !values || values.taxId == null || values.taxId.trim() === "" || values.country.value === "AT";
};

// The checkout form writes String(includesVat(...)) into the success URL, so "false" must stay false.
export const parseIncludesVat = (value: string | null) => {
	return value === "true";
};

export const getDiscountedNetPrice = (bundle: IBundle, quantity: number) => {
	const { netPrice, quantityDiscounts } = bundle;

	if (!quantityDiscounts || quantityDiscounts.length === 0) {
		return netPrice * quantity;
	}

	const qualifiedDiscount = maxBy(
		quantityDiscounts.filter((x) => x.quantity <= quantity),
		(x) => x.quantity
	);

	if (qualifiedDiscount) {
		return qualifiedDiscount.netPrice * quantity;
	}

	return netPrice * quantity;
};

export const getLocation = () => {
	return `${window.location.protocol}//${window.location.hostname}${window.location.port ? `:${window.location.port}` : ""}`;
};
